export default __webpack_public_path__ + "static/media/dyeing9.739a9a00.png";